import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

// Get language code from path
export function getLanguage(): Lang {

  const pathSegments = window.location.pathname.split('/').filter(Boolean);;
  const langCode = pathSegments[0];

  return langCode as Lang
}

// Get election id from query parameter
export function getElectionId(): number {

  const params = new URLSearchParams(window.location.search);
  const electionId = params.get("election"); // null if not present

  return Number(electionId)
}

// Get election configuration step from the hash
export function getConfigStep(): string {
  return window.location.hash.slice(1)
}

// Set election configuration step tothe hash
export function setConfigStep(step: string) {
  window.location.hash = step
}
const languages: Record<string,Record<string,string>> = {
  ca: {
    on: "el",
    from: "de",
    to: "a",
    at: "a les"
  },
  es: {
    on: "el",
    from: "de",
    to: "a",
    at: "a las"
  },
  en: {
    on: "on",
    from: "from",
    to: "to",
    at: "at"
  },
};

window.formatAndLocalizeTimePeriod = formatAndLocalizeTimePeriod
export function formatAndLocalizeTimePeriod(startTime: Date, endTime: Date, langCode:string) {
  const lang = languages[langCode];
  const tz = dayjs.tz.guess();

  const sameDay =
    new Date(startTime).toDateString() === new Date(endTime).toDateString();

  if (sameDay) {
    // Show date once, with a time range: "April 8, 2026, 9:00 AM – 5:00 PM"
    const dateFormatter = new Intl.DateTimeFormat(langCode, {
      timeZone: tz,
      dateStyle: "long",
    });
    const timeFormatter = new Intl.DateTimeFormat(langCode, {
      timeZone: tz,
      timeStyle: "short",
      hourCycle: "h23",
    });

    return (
      lang["on"] +
      " " +
      dateFormatter.format(new Date(startTime)) +
      " " +
      lang["from"] +
      " " +
      timeFormatter.format(new Date(startTime))+
      " " +
      lang["to"] +
      " " +
      timeFormatter.format(new Date(endTime))
    )
  } else {
    // Show full date and time for both: "April 8, 2026, 9:00 AM – April 9, 2026, 5:00 PM"
    const dateFormatter = new Intl.DateTimeFormat(langCode, {
      timeZone: tz,
      dateStyle: "long",
      timeStyle: "short",
    });

    return (
      lang["from"] +
      " " +
      dateFormatter.format(new Date(startTime)) +
      " " +
      lang["to"] +
      " " +
      dateFormatter.format(new Date(endTime))
    );
  }
}

// 2026/04/10 10:16-10:16
window.formatTimeRange = formatTimeRange
export function formatTimeRange(start: Date, end: Date, langCode: string)  {
  const tz = dayjs.tz.guess();

  const sameDay = new Date(start).toDateString() === new Date(end).toDateString();

  if (sameDay) {
    // Show date once, with a time range: "April 8, 2026, 9:00 AM – 5:00 PM"
    const dateFormatter = new Intl.DateTimeFormat(langCode, {
      timeZone: tz,
      weekday: "long",
      month: "long",
      day: "numeric",
      year: "numeric",
    });
    const timeFormatter = new Intl.DateTimeFormat(langCode, {
      timeZone: tz,
      hour: "2-digit",
      minute: "2-digit",
      hourCycle: "h23",
    });

    return (
      dateFormatter.format(new Date(start)) +
      ", " +
      timeFormatter.format(new Date(start))+
      " - " +
      timeFormatter.format(new Date(end))
    )
  } else {
    // Show full date and time for both: "April 8, 2026, 9:00 AM – April 9, 2026, 5:00 PM"
    const dateFormatter = new Intl.DateTimeFormat(langCode, {
      timeZone: tz,
      dateStyle: "long",
    });

    return (
      dateFormatter.format(new Date(start)) +
      " - " +
      dateFormatter.format(new Date(end))
    );
  }
}

export function capitalize(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

window.formatDateTime = formatDateTime
// 2026/04/10 10:16-10:16
export function formatDateTime(time: Date, langCode: string) {
  const lang = languages[langCode];
  const tz = dayjs.tz.guess();

  time = new Date(time)

  //const dateFormatter = new Intl.DateTimeFormat(langCode, {
  //  timeZone: tz,
  //  dateStyle: "long",
  //});
  //
  //const timeFormatter = new Intl.DateTimeFormat(langCode, {
  //  timeZone: tz,
  //  timeStyle: "short",
  //  hourCycle: "h23",
  //});

  const dateFormatter = new Intl.DateTimeFormat(langCode, {
      timeZone: tz,
      weekday: "long",
      month: "long",
      day: "numeric",
      year: "numeric",
  });
  const timeFormatter = new Intl.DateTimeFormat(langCode, {
     timeZone: tz,
      hour: "2-digit",
      minute: "2-digit",
      hourCycle: "h23",
  });


  return dateFormatter.format(time) + " "+lang["at"]+ " " + timeFormatter.format(time);
}

window.getDateTimeFormatString = getDateTimeFormatString
export function getDateTimeFormatString(lang: string): string {
  const formatStrings: Record<string,string> = {
    ca: "dddd, D [de] MMMM [de] YYYY [a les] H:mm",
    es: "dddd, D [de] MMMM [de] YYYY [a las] H:mm",
    en: "dddd, MMMM D, YYYY [at] h:mm A",
  }

  return formatStrings[lang] ?? formatStrings["en"]
}

export const SUPPORTED_LANGS = ["en", "es", "ca"] as const;// ["en", "fr", "de", "es", "ca"] as const;
export type Lang = typeof SUPPORTED_LANGS[number];

export function navigate(lang: Lang, path: string) {
  window.history.pushState({}, "", `/${lang}${path}`);
  window.dispatchEvent(new PopStateEvent("popstate"));
}

export function getPathWithoutLang() {
  const pathSegments = window.location.pathname.split('/').filter(Boolean);;
  const path = pathSegments.slice(1).join("/");
  return "/" + path + window.location.search + window.location.hash;
}

export function upsert<T>(array:T[], item: T, key: keyof T) {
  const index = array.findIndex(el => el[key] === item[key]);
  if (index !== -1) {
    array[index] = item;       // update
  } else {
    array.push(item);          // insert
  }
  return array;
}